// Every submission pins the form version it was filled in on (P10). Labels,
// options and table/matrix columns must come from that version, so the
// table, drawer and CSV look fields up per version.

// versions → { [versionId]: { [fieldId]: field } }
export const indexVersionFields = (versions) => {
  const index = {};
  (versions || []).forEach((version) => {
    const fields =
      version && version.definition && Array.isArray(version.definition.fields)
        ? version.definition.fields
        : [];
    const byId = {};
    fields.forEach((field) => {
      if (field && field.id) byId[field.id] = field;
    });
    index[version.id] = byId;
  });
  return index;
};

// The field as the row's own version defines it. When that version wasn't
// returned at all, fall back to a bare field built from the column so the
// value still formats; when the version exists but lacks the field, the row
// can't hold an answer for it (null).
export const rowField = (index, row, column) => {
  const byId = index[row.version_id];
  if (!byId) {
    return {
      id: column.field_id,
      type: column.type,
      label: column.label,
      config: {},
    };
  }
  return byId[column.field_id] || null;
};
